import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { IAlertModalState } from "../../../common/types/commonTypes";

const CREATE_EDIT_ALERT_MODAL: string = "createEditAlertModal";
const initialState: IAlertModalState = {
  isActive: false,
  isEditMode: false,
  isQuickAlert: false,
  isEditQuickAlert: false,
};
const createEditAlertModalSlice = createSlice({
  name: CREATE_EDIT_ALERT_MODAL,
  initialState,
  reducers: {
    showModal: (state: IAlertModalState) => {
      state.isActive = true;
    },
    hideModal: (state: IAlertModalState) => {
      state.isActive = false;
      state.isEditMode = initialState.isEditMode;
      state.isQuickAlert = initialState.isQuickAlert;
      state.isEditQuickAlert = initialState.isEditQuickAlert;
    },
    turnOnEditMode: (state: IAlertModalState) => {
      state.isEditMode = true;
    },
    turnOnQuickAlertMode: (state: IAlertModalState) => {
      state.isQuickAlert = true;
    },
    turnOnEditQuickMode: (state: IAlertModalState) => {
      state.isEditQuickAlert = true;
    },
  },
});
export const actions = {
  createEditAlertModalSlice,
  ...createEditAlertModalSlice.actions,
};
export const selector = (state: RootState) => state.createEditAlertModal;
export const reducer = createEditAlertModalSlice.reducer;
